import { useCallback } from "react";

import { FormatNumberOptions, IntlShape } from "react-intl";

import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import localSettings from "@app/config/LocalSettings";

import { MINIMUM_COMPAQ_NUMBER_VALUE } from "./const";

const useGrossValueFormatter = (intl: IntlShape, field?: IField) =>
  useCallback(
    (value: number): string => {
      let options: FormatNumberOptions = {
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
      };
      if (value >= MINIMUM_COMPAQ_NUMBER_VALUE) {
        options.notation = "compact";
      }
      if (field?.hasFeature(FieldFeature.MONETARY_VALUE)) {
        options = {
          ...options,
          currency: localSettings.getCurrencyCode(),
          style: "currency",
        };
      }
      return intl.formatNumber(value, options);
    },
    [intl, field]
  );

export default useGrossValueFormatter;
